const prototypeOfSimpleObject = Object.getPrototypeOf({});
/**
 * Test if the object is an object with the same prototype as Object or a null prototype.
 */
export default function isSimpleObject(obj: any): boolean {
	// Will return true for new Object(), {}, and Object.create(null). Will not return true for arrays, other objects, primitives, etc.
	if (obj === null || obj === undefined) {
		return false;
	}
	return Object.getPrototypeOf(obj) === null || Object.getPrototypeOf(obj) === prototypeOfSimpleObject;
}